import { get, post, postBlob } from '../../../../services/request';

export const getExamDataMatrixPagination = (payload) => {
	return post('Examdata/GetExamDataMatrixPagination', payload);
};

export const getAllExamDataMatrixDropDown = () => {
	return get('Examdata/GetallExamDataMatrixDropDown');
};

// Export exam data matrix as a binary workbook (not Base64-in-JSON) so very large
// date ranges avoid the size/memory overhead of the generic exportToCSVRequest flow.
export const exportExamDataMatrixToCSV = (payload) => {
	return postBlob('Examdata/ExportExamDataMatrix', payload);
};

export const getLatestExamDateRange = () => {
	return get('ExamData/GetLatestExamDateRange');
};
